import { BracketHeading } from "../shared/components/BracketHeading";
import { FlowBracket } from "../shared/components/FlowBracket";
import { BracketProps } from "../shared/types/interfaces";
// import frame from "./frame.png";

const matchIndexPositions: {
  [key: number]: {
    node: {
      x: number;
      y: number;
    };
  };
} = {
  // UB QF 1
  0: {
    node: { x: 0, y: 40 },
  },
  // UB QF 2
  1: {
    node: { x: 0, y: 144 },
  },
  // UB QF 3
  2: {
    node: { x: 0, y: 248 },
  },
  // UB QF 4
  3: {
    node: { x: 0, y: 356 },
  },
  // LB Round 1 Match 1
  4: {
    node: { x: 0, y: 493 },
  },
  // LB Round 1 Match 2
  5: {
    node: { x: 0, y: 596 },
  },
  // UB SF 1
  6: {
    node: { x: 307, y: 94 },
  },
  // UB SF 2
  7: {
    node: { x: 307, y: 303 },
  },
  // LB Round 2 Match 1
  8: {
    node: { x: 307, y: 493 },
  },
  // LB Round 2 Match 2
  9: {
    node: { x: 307, y: 596 },
  },
  // LB Final
  10: {
    node: { x: 614, y: 542 },
  },
  // UB Final
  11: {
    node: { x: 614, y: 193 },
  },
};

export const DoubleElim8Groups = ({ gameId, bracket, pickedResults, onTeamClick }: BracketProps) => {
  if (!bracket.matches) return null;

  return (
    <div className="relative w-full">
      {/* Bracket */}
      <div className="custom-scrollbar relative overflow-x-auto overflow-y-hidden">
        {/* For dev only */}
        {/* <img
          className="absolute"
          src={frame}
          style={{
            // 50% transparent red bg
            backgroundColor: "rgba(255, 0, 0, 0.5)",
            top: "0",
            width: "759px",
            minWidth: "759px",
          }}
        /> */}

        <div
          style={{
            width: "762px",
            minWidth: "762px",
            height: "693px",
            minHeight: "693px",
          }}
        >
          <BracketHeading>Upper Bracket</BracketHeading>
          <BracketHeading
            style={{
              top: "458px",
            }}
          >
            Lower Bracket
          </BracketHeading>
          <FlowBracket
            gameId={gameId}
            circuitName={bracket.circuitName}
            tournamentName={bracket.parentTournamentName}
            matchIndexPositions={matchIndexPositions}
            matches={bracket.matches}
            pickedResults={pickedResults}
            onTeamClick={onTeamClick}
          />
        </div>
      </div>
    </div>
  );
};
